export type IconStatus = 'grey' | 'green' | 'red' | 'yellow' | 'purple' | 'none'

export const getStatusColors = (status: IconStatus) => {
  const fillMap: Record<IconStatus, string> = {
    grey: 'var(--status-grey-fill)',
    green: 'var(--status-green-fill)',
    red: 'var(--status-red-fill)',
    yellow: 'var(--status-yellow-fill)',
    purple: 'var(--status-purple-fill)',
    none: '',
  }

  const strokeMap: Record<IconStatus, string> = {
    grey: 'var(--status-grey-stroke)',
    green: 'var(--status-green-stroke)',
    red: 'var(--status-red-stroke)',
    yellow: 'var(--status-yellow-stroke)',
    purple: 'var(--status-purple-stroke)',
    none: '',
  }

  return {
    fillColor: fillMap[status],
    strokeColor: strokeMap[status],
  }
}
